var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.08333H3.91667V15H1V5.08333ZM2.44958 3.91667H2.43325C1.56292 3.91667 1 3.268 1 2.45775C1 1.63 1.58042 1 2.4665 1C3.35375 1 3.90033 1.63 3.91667 2.45775C3.91667 3.26742 3.35375 3.91667 2.44958 3.91667ZM15 15H12.0833V9.69225C12.0833 8.41008 11.3687 7.53508 10.2213 7.53508C9.34575 7.53508 8.87208 8.12542 8.64225 8.69592C8.55825 8.90008 8.58333 9.46475 8.58333 9.75V15H5.66667V5.08333H8.58333V6.60933C9.00392 5.95833 9.6625 5.08333 11.3472 5.08333C13.4343 5.08333 14.9994 6.39583 14.9994 9.3265L15 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic-linkedin.4f5e40ab446ebe67c92954f513952f7b.svg";
export { ForwardRef as ReactComponent };